import React from 'react';
import theme, { getTheme } from '../../theme';
import { useDarkMode } from '../../context/DarkModeContext';

const BASE_CSS = `
@keyframes ln-shimmer {
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
}
.ln-skeleton {
  background: linear-gradient(90deg, #F3F0E8 25%, rgba(17,24,39,0.07) 37%, #F3F0E8 63%);
  background-size: 400% 100%;
  animation: ln-shimmer 1.4s ease infinite;
}
body.dark-mode .ln-skeleton {
  background: linear-gradient(90deg, #2a2420 25%, rgba(255,255,255,0.06) 37%, #2a2420 63%);
  background-size: 400% 100%;
  animation: ln-shimmer 1.4s ease infinite;
}
`;

let injected = false;
function ensureCss() {
  if (injected || typeof document === 'undefined') return;
  const style = document.createElement('style');
  style.textContent = BASE_CSS;
  document.head.appendChild(style);
  injected = true;
}

export function Skeleton({ height = '16px', width = '100%', radius = theme.radius.sm, style }) {
  ensureCss();
  return <div className="ln-skeleton" style={{ height, width, borderRadius: radius, ...style }} />;
}

export function SkeletonCard({ lines = 3 }) {
  const { isDark } = useDarkMode();
  const t = getTheme(isDark);
  return (
    <div style={{ backgroundColor: t.surface, border: `1px solid ${t.border}`, borderRadius: theme.radius.lg, padding: theme.space.xl }}>
      <Skeleton height="14px" width="40%" style={{ marginBottom: '14px' }} />
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton key={i} height="10px" width={i === lines - 1 ? '60%' : '100%'} style={{ marginBottom: '8px' }} />
      ))}
    </div>
  );
}

export default Skeleton;
